import { render, staticRenderFns } from "./navMenu.vue?vue&type=template&id=01d53f17&scoped=true"
import script from "./navMenu.vue?vue&type=script&lang=ts"
export * from "./navMenu.vue?vue&type=script&lang=ts"
import style0 from "./navMenu.vue?vue&type=style&index=0&id=01d53f17&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01d53f17",
  null
  
)

export default component.exports